<template>
  <section>
    <v-row justify="center">
      <v-col cols="2" class="text-center">
        <v-icon x-large color="green">fas fa-check-circle</v-icon>
        <div>
          <h3>Your manifest has been checked</h3>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-tabs
        v-model="tab"
        grow
        :slider-color="tab === 0 ? 'cyan accent-4' : 'red'"
      >
        <v-tab key="0">
          <v-icon class="mr-4" color="green" small>fiber_manual_record</v-icon>
          Processed
          <v-icon color="green" @click="getProcessedCSV()" class="pl-1">
            cloud_download
          </v-icon>
          <v-tooltip top color="secondary" class="white--text">
            <span>Deliveries that will be accepted, click the green cloud to download corresponding lines from the original manifest</span>
            <template v-slot:activator="{ on }">
              <v-icon class="pl-2" v-on="on">info</v-icon>
            </template>
          </v-tooltip>
        </v-tab>
        <v-tab key="1">
          <v-icon class="mr-4" color="red" small>fiber_manual_record</v-icon>
          Rejected
          <v-icon color="red" @click="getRejectedCSV()" class="pl-1">
            cloud_download
          </v-icon>
          <v-tooltip top color="secondary" class="white--text">
            <span>Deliveries that will be rejected, click the red cloud to download corresponding lines from the original manifest</span>
            <template v-slot:activator="{ on }">
              <v-icon class="pl-2" v-on="on">info</v-icon>
            </template>
          </v-tooltip>
        </v-tab>

        <v-tabs-items v-model="tab">
          <v-tab-item :key="0">
            <v-data-table
              :headers="headers"
              :items="renderedProcessedProps"
            >
              <template v-slot:item="props">
                <tr @click="displayInfo(props.item)">
                  <td style="text-align: center">{{ props.item.invoice}}</td>
                  <td style="text-align: center">{{ props.item.date}}</td>
                  <td class="text-center">{{ props.item.name}}</td>
                  <td style="text-align: center">{{ props.item.street1}}</td>
                  <td style="text-align: center">{{ props.item.suburb}}</td>
                  <td style="text-align: center">{{ props.item.state}}</td>
                  <td style="text-align: center">{{ props.item.postcode}}</td>
                  <td style="text-align: center">{{ props.item.phone1}}</td>
                  <td style="text-align: center">
                    <v-tooltip bottom v-if="props.item.tooltip_message !== null" color="secondary"
                               class="white--text">
                      <template v-slot:activator="{ on }">
                        <div v-on="on">{{props.item.tags.length}}</div>
                      </template>
                      <span>{{props.item.tooltip_message}}</span>
                    </v-tooltip>
                    <div v-else>{{props.item.tags.length}}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>

          </v-tab-item>

          <v-tab-item :key="1">
            <v-data-table
              :headers="headers"
              :items="renderedRejectedProps"
              :items-per-page="25"
            >
              <template v-slot:item="props">
                <tr>
                  <td style="text-align: center" @click="displayInfo(props.item)">
                    <v-row>
                      <v-col cols="12">
                        <v-tooltip top color="secondary">
                          <template v-slot:activator="{ on }">
                            <v-icon color="red" v-on="on" small>info</v-icon>
                          </template>
                          <span>
                              {{ props.item.validation_errors.join("; ") }}
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12">
                        {{ props.item.invoice}}
                      </v-col>
                    </v-row>
                  </td>
                  <td style="text-align: center">{{ props.item.date}}</td>
                  <td class="text-center">{{ props.item.name}}</td>
                  <td style="text-align: center">{{ props.item.street1}}</td>
                  <td style="text-align: center">{{ props.item.suburb}}</td>
                  <td style="text-align: center">{{ props.item.state}}</td>
                  <td style="text-align: center">{{ props.item.postcode}}</td>
                  <td style="text-align: center">(+61) {{ props.item.phone1}}</td>
                  <td style="text-align: center">
                    <v-tooltip bottom v-if="props.item.tooltip_message !== null" color="secondary">
                      <template v-slot:activator="{ on }">
                        <div v-on="on">{{props.item.tags.length}}</div>
                      </template>
                      <span>{{props.item.tooltip_message}}</span>
                    </v-tooltip>
                    <div v-else>{{props.item.tags.length}}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>

      </v-tabs>
    </v-row>

    <DeliveryInfoDisplayer
      :box-info="rowInfo"
      v-if="creditNoteDisplayerDialog"
      :buttons="false"
      :show-info="showInfo"
      :toggle-info-displayer="toggleInfoDisplayer"
    ></DeliveryInfoDisplayer>

    <v-row justify="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
      <v-tooltip top color="secondary" class="white--text">
        <template v-slot:activator="{ on }">
          <v-btn text color="blue-grey lighten-2" v-on="on" @click="$emit('back-to-upload')">
            Cancel
          </v-btn>
        </template>
        <span>Go back to submitting the manifest</span>
      </v-tooltip>
      <v-btn text outlined color="blue darken-1" @click="confirmDialog=true">Confirm</v-btn>
    </v-row>

    <v-dialog
      v-model="confirmDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="text-center">
          Are you sure you want to confirm this manifest ?
        </v-card-title>
        <v-card-text>
          {{confirmMessage}}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="confirmDialog = false">No</v-btn>
          <v-btn text @click="$emit('manifest-confirmed'); confirmDialog=false" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </section>
</template>

<script>
    import DeliveryInfoDisplayer from '../../pages/Delivery/Search/DeliveryInfoDisplayer'
    import ManifestChecker from "./ManifestChecker";
    // @vuese
    // Tab responsible for the confirmation of the uploaded manifest on the UploadYourManifest page.
    // Displays the tables of lines that have been approved and the one that have been rejected
    // @group Manifest
    export default {
        name: "ManifestConfirmation",
        components: {ManifestChecker, DeliveryInfoDisplayer},
        props: {
            dataTableProps: Object,
            jobId: String,
        },
        data() {
            return {
                headers: [
                    {text: 'Invoice No', value: 'invoice', align: 'center', sortable: true},
                    {text: 'Date', value: 'date', align: 'center', sortable: false},
                    {text: 'Name', value: 'name', align: 'center', sortable: false},
                    {text: 'Address', value: 'street1', align: 'center', sortable: false},
                    {text: 'Suburb', value: 'suburb', align: 'center', sortable: true},
                    {text: 'State', value: 'state', align: 'center', sortable: true},
                    {text: 'Postcode', value: 'postcode', align: 'center', sortable: false},
                    {text: 'Phone', value: 'phone1', align: 'center', sortable: false},
                    {text: 'Number of tags', value: 'tags', align: 'center', sortable: true},
                ],
                rowInfo: null,
                creditNoteDisplayerDialog: false,
                showInfo: false,
                tab: 0,
                confirmDialog: false,
            }
        },
        methods: {
            // @vuese
            // Display delivery information
            // @arg Takes the manifest row the user clicked on as an argument
            displayInfo(item) {
                this.rowInfo = item;
                if (item !== null && item !== undefined) {
                    this.showInfo = true;
                }
            },
            // @vuese
            // Toggles delivery information dialog
            toggleInfoDisplayer() {
                this.showInfo = !this.showInfo;
            },
            getProcessedCSV() {
                window.open(process.env.API_URL + '/manifests/' + this.jobId + '/interim/processed?key=' + encodeURI(this.$store.state.auth.key), '_blank')
            },
            getRejectedCSV() {
                window.open(process.env.API_URL + '/manifests/' + this.jobId + '/interim/rejected?key=' + encodeURI(this.$store.state.auth.key), '_blank')
            }
        },
        computed: {
            // @vuese
            // Returns an Array of approved lines of the manifest to be displayed in the approved tab of this page
            renderedProcessedProps() {
                this.dataTableProps.processed.map((row) => {
                    let message = '';
                    if (row.tags.length > 0) {
                        message = message + row.tags[0].transaction;
                        for (var i = 1; i < row.tags.length; i++) {
                            message = message + '; ' + row.tags[i].transaction;
                        }
                        row.tooltip_message = message;
                    } else {
                        row.tooltip_message = null;
                    }
                });
                return this.dataTableProps.processed
            },
            // @vuese
            // Returns an Array of rejected lines of the manifest to be displayed in the rejected tab of this page
            renderedRejectedProps() {
                this.dataTableProps.rejected.map((row) => {
                    let message = '';
                    if (row.tags.length > 0) {
                        message = message + row.tags[0].transaction;
                        for (var i = 1; i < row.tags.length; i++) {
                            message = message + '; ' + row.tags[i].transaction;
                        }
                        row.tooltip_message = message;
                    } else {
                        row.tooltip_message = null;
                    }
                });
                return this.dataTableProps.rejected
            },
            // @vuese
            // Message displayed when user clicks on the next step button.
            // Contains the number of rejected lines if there is any.
            confirmMessage() {
                if (this.renderedRejectedProps.length === 0) {
                    return null
                } else {
                    return 'Please note that you have ' + this.renderedRejectedProps.length + ' rejected lines. \n These lines won\'t be processed.'
                }
            }
        }
    }
</script>

<style scoped>
  .v-card__title {
    word-break: keep-all;
  }

</style>



// WEBPACK FOOTER //
// src/components/util/Manifest/ManifestConfirmation.vue